// import { useEffect, useState } from "react";
// import api from "../api/axios";
// export default function MenuMaster() {

//     const [menu, setMenu] = useState({
//         menuId: 0,
//         menuName: "",
//         menuUrl: "",
//         parentId: "",
//         icon: "",
//         displayOrder: 1,
//         isActive: true
//     });

//     const [menus, setMenus] = useState([]);

//     useEffect(() => {
//         loadMenus();
//     }, []);

//     const loadMenus = () => {
//         api.get("/Menu/GetMenu")
//             .then(res => setMenus(res.data));
//     }

//     const saveMenu = () => {

//         if (menu.menuId === 0) {
//             api.post("/Menu/", menu)
//                 .then(() => {
//                     loadMenus();
//                     resetForm();
//                 });
//         }
//         else {
//             api.put(`/Menu/${menu.menuId}`, menu)
//                 .then(() => {
//                     loadMenus();
//                     resetForm();
//                 });
//         }
//     }

//     const editMenu = (item) => {
//         setMenu(item);
//     }

//     const deleteMenu = (id) => {

//         if (window.confirm("Delete Menu?")) {

//             api.delete(`/Menu/${id}`)
//                 .then(() => loadMenus());

//         }

//     }

//     const resetForm = () => {
//         setMenu({
//             menuId: 0,
//             menuName: "",
//             menuUrl: "",
//             parentId: "",
//             icon: "",
//             displayOrder: 1,
//             isActive: true
//         });
//     }

import { useEffect, useState } from "react";
import api from "../api/axios";
import Swal from "sweetalert2";
export default function MenuMaster() {
  const [menu, setMenu] = useState({
    menuId: 0,
    menuName: "",
    menuUrl: "",
    parentId: "" | null,
    icon: "",
    displayOrder: 1,
    isActive: true,
  });

  const [menus, setMenus] = useState([]);

  useEffect(() => {
    loadMenus();
  }, []);

  const loadMenus = async () => {
    try {
      const res = await api.get("/Menu/GetMenu");
      setMenus(res.data);
    } catch (err) {
      console.error(err);
    }
  };

  const saveMenu = async () => {
    try {
      if (menu.menuId === 0) {
        await api.post("/Menu/InsertMenu", menu);

        alert("Menu Saved Successfully");
      } else {
        await api.put(`/Menu/UpdateMenu/${menu.menuId}`, menu);

        alert("Menu Updated Successfully");
      }

      loadMenus();
      resetForm();
    } catch (err) {
      // catch (err) {

      //     console.error(err);
      //     alert("Something went wrong");

      // }

      console.log(err.response);
      console.log(err.response.data);
       Swal.fire("", "JSON.stringify(err.response.data)", "warning");
      //alert(JSON.stringify(err.response.data));
    }
  };
const editMenu = (item) => {
  setMenu({
    menuId: item.menuId,
    menuName: item.menuName,
    menuUrl: item.menuUrl,
    icon: item.icon,
    displayOrder: item.displayOrder,
    isActive: item.isActive,
    parentId: item.parentId || null,
  });
};
  // const editMenu = (item) => {
  //   setMenu({
  //     ...item,
  //     parentId: item.parentId ?? "",
  //   });
  // };

  const deleteMenu = async (id) => {
    if (!window.confirm("Delete Menu?")) return;

    try {
      await api.delete(`/Menu/DeleteMenu/${id}`);

      loadMenus();
    } catch (err) {
      // catch (err) {

      //     console.error(err);

      // }
      // Swal.fire("", "Please Enter Mobile Number", "warning");
      console.log(err.response);
      console.log(err.response.data);
      alert(JSON.stringify(err.response.data));
    }
  };

  const resetForm = () => {
    setMenu({
      menuId: 0,
      menuName: "",
      menuUrl: "",
      parentId: "" | null,
      icon: "",
      displayOrder: 1,
      isActive: true,
    });
  };

  return (
   
        <div className="card shadow">
        <div className="card-header bg-primary text-white">
          <h4 className="mb-0">Menu Management</h4>
        </div>

        <div className="card-body">
          <div className="row">
            <div className="col-md-4">
              <label>Parent Menu</label>

              <select
                className="form-select"
                value={menu.parentId}
                onChange={(e) => setMenu({ ...menu, parentId: e.target.value })}
              >
                <option value="">Root Menu</option>

                {menus
                  .filter((x) => x.parentId == null)
                  .map((x) => (
                    <option key={x.menuId} value={x.menuId}>
                      {x.menuName}
                    </option>
                  ))}
              </select>
            </div>
            <div className="col-md-4">
              <label>Menu Name</label>

              <input
                className="form-control"
                value={menu.menuName}
                onChange={(e) => setMenu({ ...menu, menuName: e.target.value })}
              />
            </div>

            <div className="col-md-4">
              <label>Menu URL</label>

              <input
                className="form-control"
                value={menu.menuUrl}
                onChange={(e) => setMenu({ ...menu, menuUrl: e.target.value })}
              />
            </div>

            

            <div className="col-md-4 mt-3">
              <label>Menu Icon</label>

              <input
                className="form-control"
                value={menu.icon}
                onChange={(e) => setMenu({ ...menu, icon: e.target.value })}
              />
            </div>

            <div className="col-md-4 mt-3">
              <label>Display Order</label>

              <input
                type="number"
                className="form-control"
                value={menu.displayOrder}
                onChange={(e) =>
                  setMenu({ ...menu, displayOrder: e.target.value })
                }
              />
            </div>

            <div className="col-md-4 mt-4"><br></br>
              <div className="form-check">
                <input
                  type="checkbox"
                  className="form-check-input"
                  checked={menu.isActive}
                  onChange={(e) =>
                    setMenu({ ...menu, isActive: e.target.checked })
                  }
                />

                <label className="form-check-label">Active</label>
              </div>
            </div>

            <div className="col-12 mt-4 text-center">
              <button className="btn btn-success me-2" onClick={saveMenu}>
                <i className="bi bi-floppy"></i> Save
              </button>

              <button className="btn btn-danger" onClick={resetForm}>
                <i className="bi bi-arrow-clockwise"></i> Reset
              </button>
            </div>
          </div>

          <hr />
<div className="table-responsive"></div>
         <table className="table table-bordered table-striped">
              <thead className="table-dark">
              <tr>
                <th>ID</th>

                <th>Menu</th>

                <th>Parent</th>

                <th>URL</th>

                <th>Order</th>

                <th>Status</th>

                <th>Action</th>
              </tr>
            </thead>

            <tbody>
              {menus.map((x) => (
                <tr key={x.menuId}>
                  <td>{x.menuId}</td>

                  <td>{x.menuName}</td>

                  <td>
                    {menus.find((a) => a.menuId === x.parentId)?.menuName}
                  </td>

                  <td>{x.menuUrl}</td>

                  <td>{x.displayOrder}</td>

                  <td>
                    {x.isActive === true ? (
  <span className="badge bg-success">
  <i className="bi bi-eye-fill"></i>  Active
  </span>
) : (
  <span className="badge bg-danger">
   <i className="bi bi-eye-slash-fill"></i> Inactive
  </span>
)}
                    
                  </td>

                  <td>
                    <button
                      className="btn btn-warning btn-sm me-2"
                      onClick={() => editMenu(x)}
                    >
                     <i className="bi bi-pencil-square"></i> Edit
                    </button>

                    <button
                      className="btn btn-danger btn-sm"
                      onClick={() => deleteMenu(x.menuId)}
                    >
                    <i className="bi bi-trash"></i>  Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          </div>
        </div>
      
  
  );
}
